import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  class: "svg-icon"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M12.962 3.337a4.566 4.566 0 0 1 6.458 6.458l-7.75 7.75a2.74 2.74 0 1 1-3.874-3.875l5.812-5.812 1.291 1.291-5.812 5.812a.913.913 0 1 0 1.292 1.292l7.749-7.75a2.74 2.74 0 1 0-3.875-3.874l-7.749 7.75a4.566 4.566 0 0 0 6.458 6.457l5.812-5.812 1.291 1.292-5.812 5.812a6.393 6.393 0 0 1-9.04-9.041l7.749-7.75Z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }